import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ieltsApi } from '@/lib/ieltsApi';
import { toast } from 'sonner';

const ALLOWED_NEXT = new Set(['/ielts', '/ielts/dashboard', '/ielts/practice', '/ielts/mock-test']);
const resolveNext = (q) => {
  let n = q;
  if (!n) {
    try { n = sessionStorage.getItem('ielts_post_login_next') || ''; } catch (e) { n = ''; }
  }
  return n && ALLOWED_NEXT.has(n) ? n : '/ielts/dashboard';
};

const IeltsProfilePage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);

  useEffect(() => {
    const dest = resolveNext(searchParams.get('next'));
    const m = (window.location.hash || '').match(/session_id=([^&]+)/);
    if (!m) {
      ieltsApi.authMe().then(() => navigate(dest)).catch(() => navigate('/ielts'));
      return;
    }
    ieltsApi.authExchange(decodeURIComponent(m[1]))
      .then(() => {
        window.history.replaceState(null, '', dest);
        try { sessionStorage.removeItem('ielts_post_login_next'); } catch (e) { /* ignore */ }
        toast.success('Signed in. Welcome.');
        navigate(dest);
      })
      .catch((e) => { console.error(e); setError(e.message || 'Auth failed'); });
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      {error ? (
        <div className="text-center">
          <p className="text-red-600 mb-3" data-testid="ielts-auth-error">{error}</p>
          <button onClick={() => navigate('/ielts')} className="underline">Back to IELTS home</button>
        </div>
      ) : (
        <div className="flex items-center gap-2 text-gray-600">
          <Loader2 className="h-5 w-5 animate-spin" /> Signing you in…
        </div>
      )}
    </div>
  );
};
export default IeltsProfilePage;
